import React from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';
import config from 'files/api.js';
import PageLayout from 'views/PageLayout.js';
import Accordion from 'views/Accordion.js';
import { generalFaqs, sensorFaqs } from 'files/FaqData.js';

const FaqPage = () => {

    const group = (heading, items) => (
        <div style={{ marginBottom: Utils.isMobile() ? 48 : 64 }}>
            <h2 style={{ ...Appearance.textStyles.heading({ fontSize: Utils.isMobile() ? 22 : 28 }), marginBottom: 16 }}>
                {heading}
            </h2>
            <Accordion items={items} />
        </div>
    );

    return (
        <PageLayout
            eyebrow={'Support'}
            title={'Frequently asked questions'}
            subtitle={'Everything about the network, plus setup and troubleshooting for the sensors themselves.'}>

            {group('General', generalFaqs)}
            {group('Sensors & devices', sensorFaqs)}

            {/* Still need help */}
            <div style={{
                textAlign: 'center',
                padding: Utils.isMobile() ? '36px 24px' : '48px 40px',
                borderRadius: 20,
                backgroundColor: Appearance.colors.offWhite,
            }}>
                <h3 style={{ ...Appearance.textStyles.subHeading(), marginBottom: 8 }}>{'Still have a question?'}</h3>
                <p style={{ ...Appearance.textStyles.body(), marginBottom: 6 }}>
                    {'Our U.S.-based support team is here to help.'}
                </p>
                <a href={`mailto:${config.store.email}`} style={{ ...Appearance.textStyles.body({ color: Appearance.colors.primary(), fontWeight: 600 }), textDecoration: 'none' }}>
                    {`${config.store.email} · ${config.store.phone}`}
                </a>
            </div>
        </PageLayout>
    );
};

export default FaqPage;
